import styled from 'styled-components';
import { Selector } from '@web-chat-core/ui-kit';

export const StyledSelector = styled(Selector)`
    .selector__control {
        white-space: nowrap;
    }
    .selector__menu {
        background: ${(props) => props.theme.root.colors.background['02Second']};
    }

    &.selector--is-disabled {
        pointer-events: auto; 

        .selector__control {
            background: ${(props) => props.theme.root.colors.basicColors['4%']};
            cursor: not-allowed;
        }
        .selector__single-value {
            color: ${(props) => props.theme.selector.disabled.color};
        }
`;
